import React from "react";
import { Alert, Button, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { localePath } from "../i18n/config";
import CartItem from "../components/CartItem";
import StepsHeader from "../components/StepsHeader";
import StepsNotification from "../components/StepsNotification";
import { AppState, ProductType } from "../redux/types";
import { categoryOptions } from "../utils/constants";
import { getCurrencySymbol, numericPrice } from "../utils/currency";

const Cart: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const category = new URLSearchParams(location.search).get("category");
    const user = useSelector((state: AppState) => state.user);
    const selectedServices = useSelector((state: AppState) => state.cart.inCart);
    const regionCode = useSelector((state: AppState) => state.region?.code ?? "FI");
    const currencySymbol = getCurrencySymbol(regionCode);

    const submitHandler = () => {
        if (user.isLoggedIn || category === categoryOptions.alarm || category === categoryOptions.accessories) {
            history.push(localePath("toimitus"));
        } else {
            history.push(localePath("luo_tili"));
        }
    };

    // back button
    const handleClick = () => {
        history.goBack();
    };

    const totalPrice = selectedServices.reduce((total, item) => total + numericPrice(item), 0);

    return (
        <>
            <StepsHeader step1 user={1} payment={1} account={1} />
            <Container className="shoppingcart-container">
                <Row>
                    <Col className="shoppingcart-services-col" md={8}>
                        <h1 className="shoppingcart-header">Ostoskori</h1>
                    </Col>
                </Row>
                <Row>
                    <Col className="shoppingcart-services-col" md={8}>
                        {selectedServices.length === 0 ? (
                            <Alert
                                style={{
                                    background: "rgba(78,81,128,0.8)",
                                    color: "#ffffff",
                                    marginBottom: 42,
                                }}
                            >
                                Ostoskorisi on tyhjä{" "}
                                <Link
                                    to={localePath("osta")}
                                    style={{
                                        color: "#ffffff",
                                    }}
                                >
                                    Valitse palvelu
                                </Link>
                            </Alert>
                        ) : (
                            <ListGroup variant="flush">
                                {selectedServices.map((service: ProductType, key) => (
                                    <CartItem key={key} service={service} />
                                ))}
                            </ListGroup>
                        )}
                        <Button onClick={handleClick} className="btn-block shoppingcart-back-button d-none d-md-block">
                            Edellinen
                        </Button>
                    </Col>
                    <Col md={4} className="price-sum-col">
                        <Card>
                            <ListGroup variant="flush">
                                <ListGroup.Item className="text-center">
                                    <h2>{totalPrice} {currencySymbol}</h2>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <Row className="d-md-none my-4">
                                        <Col xs={6}>
                                            <Button onClick={handleClick} className="btn-block shoppingcart-back-button" style={{ margin: 0 }}>
                                                Edellinen
                                            </Button>
                                        </Col>
                                        <Col xs={6}>
                                            <Button type="button" className="btn-block tallenna" onClick={submitHandler} disabled={!selectedServices.length} style={{ margin: 0 }}>
                                                Seuraava
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Button type="button" className="btn-block tallenna d-none d-md-block" onClick={submitHandler} disabled={!selectedServices.length}>
                                        Seuraava
                                    </Button>
                                </ListGroup.Item>
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <StepsNotification />
        </>
    );
};

export default Cart;
